import React from 'react';
import { MapPin } from 'lucide-react';
import { CountryMap, resolveCountry } from '@/components/graphics/CountryMap';

export const OfficeCard = ({ office }) => {
  if (!office) return null;
  const { label } = resolveCountry(office.name);
  return (
    <div className="bg-white border border-ophir-grey rounded-2xl overflow-hidden shadow-ophir">
      <div className="aspect-[16/10] bg-ophir-ivory-soft">
        <CountryMap country={office.name} />
      </div>
      <div className="p-5 min-h-[92px]">
        <div className="flex items-center gap-2">
          <MapPin size={20} className="text-ophir-gold-deep" />
          <h3 className="font-serif font-bold text-[22px] text-ophir-navy-deep">{label}</h3>
        </div>
        {/* Address / status intentionally left empty per brand request */}
      </div>
    </div>
  );
};

export const LocationsGrid = ({ locations = [] }) => (
  <div className="grid sm:grid-cols-2 gap-6 lg:gap-8">
    {locations.map((o, i) => (
      <OfficeCard key={i} office={o} />
    ))}
  </div>
);
